module.exports = "/packs/009-39c6fcbf8ddc06bc027cd8da87bba8e0.svg";